/* eslint-disable no-alert */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import ContactForm from '../../components/Directory/ContactForm';

function CreateEntry(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const { t } = props;

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="8">
            <Card>
              <CardBody>
                <CardTitle className="h4">{t('Create New Contact')}</CardTitle>
                <ContactForm
                  onSuccess={
                    (ent) => {
                      history.push(`/directory/entry/${ent.id}`);
                    }
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

CreateEntry.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(CreateEntry));
